import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';

const StyledRow = styled(Row)`
  margin-top: 16px;
  margin-bottom: 8px;
  border-bottom: 2px solid #e0e0e0;
  padding: 8px 0;
  font-weight: 600;
  color: #333;
`;

const StyledCol = styled(Col)`
  padding: 8px 12px;
  display: flex;
  align-items: center;
  border-right: 1px solid #e0e0e0;
  &:last-child {
    border-right: none;
  }
`;

export const GoodsItemHeader = () => {
  return (
    <StyledRow>
      <StyledCol md={1}>Артикул</StyledCol>
      <StyledCol md={2}>Название</StyledCol>
      <StyledCol md={3}>МП</StyledCol>
      <StyledCol md={1}>FBS</StyledCol>
      <StyledCol md={1}>Комбо</StyledCol>
      <StyledCol md={1}>Бренд</StyledCol>
      <StyledCol md={1}>Категория</StyledCol>
      <StyledCol md={1}>Теги</StyledCol>
      <StyledCol md={1} style={{ justifyContent: 'center' }}>
        &nbsp;
      </StyledCol>
    </StyledRow>
  );
};
